/**
 * 任意の桁で四捨五入する関数
 * @param {number} value 四捨五入する数値
 * @param {number} base どの桁で四捨五入するか（10→10の位、0.1→小数第１位）
 * @return {number} 四捨五入した値
 */
function orgRound(value, base) {
    if (isDecimal(value)) {
        return Math.round(value * base) / base;
    } else {
        return value;
    }
}

/**
 * 任意の桁で切り上げする関数
 * @param {number} value 切り上げする数値
 * @param {number} base どの桁で切り上げするか（10→10の位、0.1→小数第１位）
 * @return {number} 切り上げした値
 */
function orgCeil(value, base) {
    if (isDecimal(value)) {
        return Math.ceil(value * base) / base;
    } else {
        return value;
    }
}

/**
 * 任意の桁で切り捨てする関数
 * @param {number} value 切り捨てする数値
 * @param {number} base どの桁で切り捨てするか（10→10の位、0.1→小数第１位）
 * @return {number} 切り捨てした値
 */
function orgFloor(value, base) {
    if (isDecimal(value)) {
        return Math.floor(value * base) / base;
    } else {
        return value;
    }
}

/**
 * 小数点以下が存在するか判定する関数
 * @param {number} value 判定する数値
 * @return {boolean} 判定した結果
 */
function isDecimal(value){
    var regex = new RegExp(/^[0-9]+(\.[0-9]+)?$/);
    return regex.test(value);
}

/**
 * 数値をカンマ非表示する関数
 * @param {string} value 数値
 * @return {number} 結果
 */
function disFigure(value){
    if (typeof value == "number") {
        value = new String(value);
    }
    var num = parseInt(value.split(',').join('').trim());
    return num;
}

/**
 * 数値をカンマ表示する関数
 * @param {number} value 数値
 * @return {string} 結果
 */
function addFigure(value) {
    var str = new String(value).replace(/,/g, "");
    while(str != (str = str.replace(/^(-?\d+)(\d{3})/, "$1,$2")));
    return str;
}

export default {
    orgRound,
    orgCeil,
    orgFloor,
    disFigure,
    addFigure
}